import axiosInstance from 'api/axiosInstance';

// Backend API response type
interface ProspectStatus {
	Id: number;
	Status: string;
}

// API response type
interface SProspectStatusResponse {
	TotalResults: string;
	Data: ProspectStatus[];
}

/**
 * Fetches the full list of prospect statuses from the `SProspectStatus` API endpoint.
 * @param {number} page - The page number to fetch (1-based index).
 * @param {number} pageSize - The number of records to fetch per page.
 * @returns {Promise<{statuses: ProspectStatus[]; total: number}>} - A promise resolving to the data formatted for usage.
 */
async function getProspectStatuses(
	page: number = 1,
	pageSize: number = 20,
): Promise<{ statuses: ProspectStatus[]; total: number }> {
	try {
		console.log(
			`DEBUG getProspectStatuses.ts: Fetching statuses for page ${page} with pageSize ${pageSize}`,
		);

		const { data } = await axiosInstance.get<SProspectStatusResponse>(
			`/api/cantrackv3/SProspectStatus`,
			{
				params: {
					id: 0, // Default ID (fetch all statuses)
					searchKeyword: '', // No filtering
					page, // Page number
					take: pageSize, // Number of records
				},
			},
		);

		const totalResults = parseInt(data.TotalResults || '0', 10);

		return {
			statuses: data.Data.map((status) => ({
				Id: status.Id,
				Status: status.Status,
			})),
			total: totalResults,
		};
	} catch (error) {
		console.error(
			`DEBUG getProspectStatuses.ts: Error occurred while fetching statuses:`,
			error,
		);
		throw error;
	}
}

export default getProspectStatuses;
